import styled from 'styled-components'
import Link from 'next/link'
import {
  background,
  space,
  layout,
  typography,
  color,
  flexbox,
  border,
  position,
  shadow,
} from 'styled-system'

// TODO Break up this file. Fix Styled Link being broken.
const BaseImage = styled.img`
  ${color} ${typography} ${space} ${layout} ${border} ${flexbox}
`
const BaseP = styled.p`
  ${color} ${typography} ${layout} ${space} ${border} ${flexbox}
`
export const LinkCard = styled.a`
  ${color} ${typography} ${space} ${layout} ${border} text-decoration: none
`
export const Input = styled.input`
  ${color} ${typography} ${layout} ${space} ${border} ${flexbox}
`
export const BaseLink = styled(Link)`
  ${color} ${typography} ${layout} ${space} ${border} ${flexbox}
`
export const H1 = (props) => (
  <BaseP
    as='h1'
    fontSize={{ _: '25px', tablet: '35px', desktop: '45px' }}
    lineHeight={{ _: '25px', tablet: '45px' }}
    color='textColor'
    mb='50px'
    {...props}
  >
    {props.children}
  </BaseP>
)
export const H3 = (props) => (
  <BaseP
    as='h3'
    fontSize={{ _: '18px', tablet: '25px' }}
    lineHeight={{ _: '27px', tablet: '37.5px' }}
    fontWeight='400'
    textAlign='center'
    color='textColor'
    {...props}
  >
    {props.children}
  </BaseP>
)
export const H6 = (props) => (
  <BaseP
    as='h6'
    fontSize={{ _: '18px', tablet: '36px' }}
    lineHeight={{ _: '25px', tablet: '45px' }}
    color='textColor'
    {...props}
  >
    {props.children}
  </BaseP>
)
export const P = (props) => (
  <BaseP
    paddingRight='5px'
    fontSize={{ _: '16px', tablet: '18px' }}
    maxWidth='300px'
    color='textColor'
    {...props}
  >
    {props.children}
  </BaseP>
)

const BaseButton = styled.button`
  ${space} ${layout} ${color}
`

const BaseDiv = styled.div`
  ${layout} ${color} ${flexbox} ${space} ${border} ${position} ${shadow} ${typography} ${background}
`
export const FlexRowDiv = (props) => (
  <BaseDiv
    display='flex'
    flexDirection='row'
    justifyContent='center'
    width='100%'
    overflowX='hidden'
    {...props}
  />
)

export const CenteringDiv = (props) => (
  <BaseDiv
    display='flex'
    flexDirection='column'
    alignItems='center'
    justifyContent='flex-start'
    margin-right={{ _: '25px', tablet: '0px' }}
    margin-left={{ _: '25px', tablet: '0px' }}
    {...props}
  >
    {props.children}
  </BaseDiv>
)
export const CenteringContainer = (props) => (
  <FlexRowDiv backgroundColor='#fbfbfb'>
    <CenteringDiv maxWidth='1259px' mb='50px' mt='100px'>
      {props.children}
    </CenteringDiv>
  </FlexRowDiv>
)
export const FlexDiv = (props) => <BaseDiv display='flex' {...props} />
export const Image = (props) => <BaseImage {...props}>{props.children}</BaseImage>

export const Card = (props) => (
  <BaseDiv width='400px' display='flex' flexDirection='column' {...props}>
    {props.children}
  </BaseDiv>
)

export const Button = (props) => <BaseButton />

export const PrimaryButton = styled.a`
  text-decoration: none;
  font-weight: 700;
  color: #fff;
  display: inline-block;
  margin-bottom: 0;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  white-space: nowrap;
  padding: 6px 12px;
  line-height: 1.428571429;
  border-radius: 5px;
  user-select: none;
  background-color: ${(props) => props.theme.colors.inverseColor};
  border-color: #357ebd;
  :hover {
    background-color: ${(props) => props.theme.colors.secondary};
    border-color: #ac8900;
    transition: all 0.2s ease-in-out;
    border: 0;
  }
  ${typography}
  ${space}
  ${layout}
`
export const Box = (props) => <BaseDiv {...props}>{props.children}</BaseDiv>
export const TransitionDiv = styled(BaseDiv)`
  display: flex;
  transition-duration: 0.3s;
  transition-property: transform;
  transition-timing-function: ease-out;
  transform: transform(0px);
  :hover {
    transform: translate(0px, -15px);
    border: 1px red solid;
  }
`
export const A = (props) => (
  <P as='a' {...props}>
    {props.children}
  </P>
)
